import { render, staticRenderFns } from "./CollapseGroup.vue?vue&type=template&id=57a4c600&"
import script from "./CollapseGroup.vue?vue&type=script&lang=js&"
export * from "./CollapseGroup.vue?vue&type=script&lang=js&"
import style0 from "./CollapseGroup.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports